export class Transaction {
	description: string
	sale_amount: number
	amount: number
	balance?: number
	user_id?: number
}